import { Component, EventEmitter, Output, signal } from '@angular/core';
import { Create1Component } from './steps/create-1/create-1.component';
import { Create2Component } from './steps/create-2/create-2.component';
import { Create3Component } from './steps/create-3/create-3.component';

@Component({
  selector: 'app-create',
  imports: [Create1Component, Create2Component, Create3Component],
  templateUrl: './create.component.html',
  styleUrl: './create.component.css',
})
export class CreateComponent {
  currentStep = signal(1);
  stepChanged = new EventEmitter<number>();

  onStepChange(stepNb: number) {
    console.debug('Step changed to', stepNb);
    this.currentStep.set(stepNb);
  }
}
